import React, { useRef, useEffect } from 'react';
import {
  PhoneField, useFormContext,
} from 'lidya-common-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import classNames from 'classnames';
import { useGlobalData } from '../../../../providers/globalDataProvider/globalDataProvider.useGlobalData';
import { COUNTRY_LANGUAGE_LIST } from '../../../common/webSiteLanguages';
import { PHONE_PREFIXES } from '../../../common/providers/phonePrefixList';

export const PhoneFieldComponent = function () {
  const { t } = useTranslation();
  const { country } = useGlobalData();
  const countryDefs = COUNTRY_LANGUAGE_LIST[country];
  const { code: countryCode } = countryDefs;
  const phonePrefixes = PHONE_PREFIXES.sort((a, b) => (a.country_iso > b.country_iso ? 1 : -1));
  const element = useRef();
  useEffect(() => {
    element.current = document.body;
    return () => {};
  }, []);
  const { values: { telephone } } = useFormContext();

  return (
    <PhoneField
      name="telephone"
      id="telephone"
      label={t('web.careers.openings.form.phoneNumber')}
      size={6}
      countryCode={countryCode}
      countryList={phonePrefixes}
      required
      tooltipContainer={element.current}
      maxHeight="30vh"
      className={classNames('a-signupFormField', { 'a-signupFormField__withValue': telephone.length })}
      countryInputClassname={classNames('a-signupFormField', { 'a-signupFormField__withValue': telephone.length })}
    />
  );
};

PhoneFieldComponent.propTypes = {};

export default PhoneFieldComponent;
